var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetWrapper',{staticClass:"app-sheet-location-small"},[_c('AppSheetRow',[_c('AppSheetTitle',{attrs:{"title":_vm.titleContent,"align":_vm.titleAlignment}})],1),_c('AppSheetRow',[_c('AppRichText',{attrs:{"html-content":_vm.htmlContent,"compact":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }